import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { esParaVos, noEsParaVos } from '../data/comparativa';
export function ParaQuien() {
  return <section aria-labelledby="para-quien-titulo" className="w-full bg-surface px-6 py-20" data-id="element-170" data-mp="80r4m7zpbk6x">
      <div className="mx-auto max-w-content" data-id="element-171" data-mp="340nrig2okkg">
        <h2 id="para-quien-titulo" className="sr-only" data-id="element-172" data-mp="3uak93rjjbsx0">
          Para quién es este sistema
        </h2>

        <div className="grid gap-6 lg:grid-cols-2" data-id="element-173" data-mp="vsog1xz8oa7i">
          <div className="rounded-3xl border border-brand-200 bg-soft p-8" data-id="element-174" data-mp="vqbz9o57w5w1">
            <h3 className="font-display text-xl font-bold text-ink" data-id="element-175" data-mp="qtv1s3c4of6a">✅ Este sistema es para vos si…</h3>
            <ul className="mt-6 space-y-4" data-id="element-176" data-mp="lsntm362pdz3">
              {esParaVos.map(item => <li key={item} className="flex items-start gap-3" data-id="element-177" data-mp="hrvjz8tah72a">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-500" data-id="element-178" data-mp="36kzeuchxl98f">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-179" data-mp="32ht7t2mzve0w" />
                  </span>
                  <span className="text-sm leading-snug text-body" data-id="element-180" data-mp="3t4zocewvuwhn">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-edge bg-canvas p-8" data-id="element-181" data-mp="3k308vr1io0gt">
            <h3 className="font-display text-xl font-bold text-ink" data-id="element-182" data-mp="3k2qd1mtsiz37">❌ No es para vos si…</h3>
            <ul className="mt-6 space-y-4" data-id="element-183" data-mp="3o2s83d50su9i">
              {noEsParaVos.map(item => <li key={item} className="flex items-start gap-3" data-id="element-184" data-mp="3abm2r0f282ep">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-edge" data-id="element-185" data-mp="3f46rvon0trbw">
                    <XIcon className="h-3 w-3 text-brand-800" aria-hidden="true" data-id="element-186" data-mp="30g2b4q7j3pvr" />
                  </span>
                  <span className="text-sm leading-snug text-muted" data-id="element-187" data-mp="35evnugezrcuv">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}